module.exports = __webpack_public_path__ + "img/ps.7a787620.svg";